// Helpers de date format français (JJ/MM/AAAA), fuseau Europe/Paris.

const FORMAT_DATE_FR = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const FORMAT_DATE_HEURE_FR = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const FORMAT_DATE_LONGUE_FR = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export function formatDateFr(date: Date | string | null | undefined): string {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  return FORMAT_DATE_FR.format(d);
}

export function formatDateHeureFr(date: Date | string | null | undefined): string {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  return FORMAT_DATE_HEURE_FR.format(d);
}

export function formatDateLongueFr(date: Date | string | null | undefined): string {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  return FORMAT_DATE_LONGUE_FR.format(d);
}

/** Parse une date au format français JJ/MM/AAAA. Retourne null si invalide. */
export function parseDateFr(input: string): Date | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(input.trim());
  if (!match) return null;
  const [, dd, mm, yyyy] = match;
  const date = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Date du jour en YYYY-MM-DD (utile pour Postgres DATE). */
export function aujourdhuiIso(): string {
  const now = new Date();
  return now.toISOString().slice(0, 10);
}

/** Ajoute N jours à une date. */
export function ajouterJours(date: Date, jours: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + jours);
  return result;
}

/** Différence en jours entre deux dates (positif si fin > debut). */
export function diffJours(debut: Date, fin: Date): number {
  const ms = fin.getTime() - debut.getTime();
  return Math.floor(ms / (1000 * 60 * 60 * 24));
}
